<template>
  <div class="news">
      <div class="title-box">
        <div class="title">{{ list.name }}</div>
        <div><el-link v-if="list.url" :underline="false" class="more" :href="'#'+'/article'+list.url">更多 +</el-link></div>
      </div>
      <div class="body-box">
        <ul>
          <template v-for="item,index in list.contents" :key="item.id">
            <li v-if="index <= 10">
            <el-link :underline="false" :href="'#'+'/article'+list.url+'/'+item.id">
              <div class="item-date"><span class="day">{{ getDay(item.created_at) }}</span><span class="month">{{ getMonth(item.created_at) }}</span></div><div class="item">{{ item.subject }}</div>
            </el-link>
          </li>
          </template>
        </ul>
      </div>
  </div>
</template>
<script>
export default ({
  name: "Notice",
  props: {
    list: Object,
  },
  methods: {
    getDay(date) {
      return date.substring('8')
    },
    getMonth(date) {
      return date.substring('0', '7')
    }
  }
})
</script>

<style scoped>
/deep/ .el-link {
  font-size: 16px;
}
.body-box ul li{
  width: 386px;
  height: 70px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  align-items: flex-start;
  justify-content: space-around;
  line-height: 22px;
  border-bottom: 1px dashed #E3E3E3;
}
.body-box ul li:last-child {
  border: none;
}
.item {
  width: 330px;
  height: 40px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-date {
  width: 45px;
  height: 42px;
  float: left;
  aligin-self:center;
  background: #ff0000;
  margin-right: 10px;
  background: url("../assets/images/date.png");
  background-size: 45px 42px;
  color: #fff;
}
.item-date .day {
  width: 45px;
  height: 25px;
  text-align: center;
  display: block;
  font-size: 20px;
  line-height: 30px;
}
.item-date .month {
  width: 45px;
  height: 12px;
  text-align: center;
  display: block;
  font-size: 11px;
  line-height: 15px;
}
.news {
  width: 386px;
  height: 820px;
  float: left;
}
.title-box {
  width: 386px;
  height: 36px;
  background: #F3F3F3;
  border-bottom: 2px solid #E3E3E3;
  margin-bottom: 10px;
}
.title {
  width: 100px;
  height: 34px;
  text-align: center;
  border-bottom:4px solid #BF2E11;
  float: left;
  color: #BF2E11;
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
}
.more {
  width: 60px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  float: right;
  font-size: 12px;
}
</style>